if(document.body.contains(document.querySelector('.calculator-forms'))){
    // Trigger button
    const buttonTrigger = document.querySelector('.calculator-forms .js-calculate-cro');

    // Forms inputs
    const croForm = document.querySelector('.calculator-forms');
    const revenueInput = croForm.querySelector('.revenue-input');
    const conversionRateInput = croForm.querySelector('.conversion-rate-input');
    const aovInput = croForm.querySelector('.aov-input');

    const dateInput = croForm.querySelector('input[type="radio"]:checked').value;
    
    function calculate(crc, cr, currentAov){
        const dateInput = croForm.querySelector('input[type="radio"]:checked').value;

        console.log(dateInput);

        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
        });

        // Overlay display panels
        const overlayBlocks = document.querySelector('.cro-calculate-blocks');

        // Current values
        const currentCrc = overlayBlocks.querySelectorAll('.current-cr');
        const currentRevenue = overlayBlocks.querySelectorAll('.current-revenue');
        const currentAo = overlayBlocks.querySelectorAll('.current-aov');
        const dateForm = overlayBlocks.querySelectorAll('.date');

        // Result Values of CRC
        const cgrccfc = overlayBlocks.querySelector('.cr-co-fc .value');
        const cgrccsc = overlayBlocks.querySelector('.cr-co-sc .value');
        const cgrcctc = overlayBlocks.querySelector('.cr-co-tc .value');

        const cgraofc = overlayBlocks.querySelector('.cr-ao-fc .value');
        const cgraosc = overlayBlocks.querySelector('.cr-ao-sc .value');
        const cgraotc = overlayBlocks.querySelector('.cr-ao-tc .value');

        const cgrasfc = overlayBlocks.querySelector('.cr-add-fc .value');
        const cgrassc = overlayBlocks.querySelector('.cr-add-sc .value');
        const cgrastc = overlayBlocks.querySelector('.cr-add-tc .value');

        // Result Values of AOV
        const agrccfc = overlayBlocks.querySelector('.aov-co-fc .value');
        const agrccsc = overlayBlocks.querySelector('.aov-co-sc .value');
        const agrcctc = overlayBlocks.querySelector('.aov-co-tc .value');

        const agraofc = overlayBlocks.querySelector('.aov-ao-fc .value');
        const agraosc = overlayBlocks.querySelector('.aov-ao-sc .value');
        const agraotc = overlayBlocks.querySelector('.aov-ao-tc .value');

        const agrasfc = overlayBlocks.querySelector('.aov-add-fc .value');
        const agrassc = overlayBlocks.querySelector('.aov-add-sc .value');
        const agrastc = overlayBlocks.querySelector('.aov-add-tc .value');

        // Potential monthly sales
        const ptsfc = overlayBlocks.querySelector('.pt-fc .value');
        const ptssc = overlayBlocks.querySelector('.pt-sc .value');
        const ptstc = overlayBlocks.querySelector('.pt-tc .value');

        dateForm.forEach((item)=> item.textContent = dateInput)

        currentCrc.forEach((item)=> item.innerHTML = `${crc}%`)

        currentRevenue.forEach((item)=> item.innerHTML = USDollar.format(cr.toFixed(0)))

        currentAo.forEach((item)=> item.innerHTML = USDollar.format(currentAov.toFixed(0)))

        // Conversion Rate
        let crcccOne = crc * (1 + (0.01 * 1));
        let crcccTwo = crc * (1 + (0.03 * 1));
        let crcccThree = crc * (1 + (0.05 * 1));

        let crcaoOne = cr * (1+ 0.01);
        let crcaoTwo = cr * (1+ 0.03);
        let crcaoThree = cr * (1+ 0.05);

        let crcasOne = cr * (1/100);
        let crcasTwo = cr * (3/100);
        let crcasThree = cr * (5/100);

        // AOV Change 
        let acaoOne = currentAov * (1+ 0.05);
        let acaoTwo = currentAov * (1+ 0.2);
        let acaoThree = currentAov * (1+ 0.3);

        let arcaoOne = cr * (1+ 0.05);
        let arcaoTwo = cr * (1+ 0.2);
        let arcaoThree = cr * (1+ 0.3);

        let arcasOne = cr * (5/100);
        let arcasTwo = cr * (20/100);
        let arcasThree = cr * (30/100);

        //Potential total sales
        let ptfc = cr * (crcccOne/crc) * (acaoOne/currentAov);
        let ptsc = cr * (crcccTwo/crc) * (acaoTwo/currentAov);
        let pttc = cr * (crcccThree/crc) * (acaoThree/currentAov);

        // Conversion rate results
        cgrccfc.innerHTML = `${crcccOne.toFixed(2)}%`;
        cgrccsc.innerHTML = `${crcccTwo.toFixed(2)}%`;
        cgrcctc.innerHTML = `${crcccThree.toFixed(2)}%`;

        cgraofc.innerHTML = USDollar.format(crcaoOne.toFixed(0));
        cgraosc.innerHTML = USDollar.format(crcaoTwo.toFixed(0));
        cgraotc.innerHTML = USDollar.format(crcaoThree.toFixed(0));
        
        cgrasfc.innerHTML = USDollar.format(crcasOne.toFixed(0));
        cgrassc.innerHTML = USDollar.format(crcasTwo.toFixed(0));
        cgrastc.innerHTML = USDollar.format(crcasThree.toFixed(0));

        // AOV rate results
        agrccfc.innerHTML = USDollar.format(acaoOne.toFixed(0));
        agrccsc.innerHTML = USDollar.format(acaoTwo.toFixed(0));
        agrcctc.innerHTML = USDollar.format(acaoThree.toFixed(0));

        agraofc.innerHTML = USDollar.format(arcaoOne.toFixed(0));
        agraosc.innerHTML = USDollar.format(arcaoTwo.toFixed(0));
        agraotc.innerHTML = USDollar.format(arcaoThree.toFixed(0));
        
        agrasfc.innerHTML = USDollar.format(arcasOne.toFixed(0));
        agrassc.innerHTML = USDollar.format(arcasTwo.toFixed(0));
        agrastc.innerHTML = USDollar.format(arcasThree.toFixed(0));

        // Potential total sales result
        ptsfc.innerHTML = USDollar.format(ptfc.toFixed(0));
        ptssc.innerHTML = USDollar.format(ptsc.toFixed(0));
        ptstc.innerHTML = USDollar.format(pttc.toFixed(0));
    }

    buttonTrigger.addEventListener('click',(e)=>{
        calculate(parseFloat(conversionRateInput.value), parseFloat(revenueInput.value), parseFloat(aovInput.value));
    })
}